import React from "react";
import PropTypes from "prop-types";
import UserFound from "./UserFound";
import TeamFound from "./TeamFound";
import { useAuth } from "components/context/auth";
import TeamCardItem from "components/search/TeamCardItem";

const generateSkillObjNodes = (userObj, skillName, keyInd) => {
  return (
    <UserFound
      userObj={userObj}
      key={`${userObj.public_user_id}${keyInd}`}
      skill={skillName}
    />
  );
};

const notFound = (
  <div className="container--no_results">
    <h3 className="header header--search_results">No teams found</h3>
  </div>
);

const ResultsList = ({ resultsArr, resultsType, userData }) => {
  // console.log("ResultsList props - resultsType:", resultsType, "resultsArr:", resultsArr);
  // const {user:userData}=useAuth()
  // Determine list to render
  if (resultsType === "users") {
    return Array.isArray(resultsArr)
      ? resultsArr.map((userObj, index) => (
        userObj?.id!=userData?.id&&
          <UserFound
            userObj={userObj}
            key={`${userObj.public_user_id}${index}`}
          />
        ))
      : null;
  } else if (resultsType === "organizations") {
    return Array.isArray(resultsArr)
      ? resultsArr.map((teamObj) => (
        <TeamCardItem    teamObj={teamObj}
        key={teamObj.public_team_id}
        resultsType={resultsType}/>
          // <TeamFound
          //   teamObj={teamObj}
          //   key={teamObj.public_team_id}
          //   resultsType={resultsType}
          // />
        ))
      : null;
  } else if (resultsType === "premium") {
    return Array.isArray(resultsArr)
      ? resultsArr.map((teamObj) => (
        <TeamCardItem    teamObj={teamObj}
        key={teamObj.public_team_id}
        resultsType={resultsType}/>
          // <TeamFound
          //   teamObj={teamObj}
          //   key={teamObj.public_team_id}
          //   resultsType={resultsType}
          // />
        ))
      : null;
  }  else if (resultsType === "basic") {
    return Array.isArray(resultsArr)
      ? resultsArr.map((teamObj) => (
        <TeamCardItem    teamObj={teamObj}
        key={teamObj.public_team_id}
        resultsType={resultsType}/>
          // <TeamFound
          //   teamObj={teamObj}
          //   key={teamObj.public_team_id}
          //   resultsType={resultsType}
          // />
        ))
      : null;
  } else if (resultsType === "skill") {
    console.log(resultsArr)
    return Array.isArray(resultsArr)
    ? resultsArr.map((userObj, index) => (
      (
          <UserFound
            userObj={userObj}
            key={`${userObj.public_user_id}${index}`}
          />
        )))
      : console.log(Hello)
    }
return null
};

export default ResultsList;

ResultsList.propTypes = {
  resultsArr: PropTypes.array,
  resultsType: PropTypes.string,
};
